const Screens = {
  screenXsMin: 321,
  screenSmMin: 376,
  screenMdMin: 601,
  screenLgMin: 769,
  screenXlgMin: 1025
};
export { Screens };
